var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isLoading)?_c('div',{attrs:{"id":"spinner"}},[_c('LoadingSpinner')],1):_vm._e(),_c('UserDetails',{attrs:{"countries":_vm.countries,"business_types":_vm.business_types}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }